// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.lunch_datepicker {
    margin-left: 10px;
    width: 176px;
    height: 50px;
    border: 1px solid #CDE1EB;
    border-radius: 5px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding-left: 15px;
    padding-right: 10px;
}
@media (max-width: 600px) {
    .lunch_datepicker {
        width: 150px;
    }
}
.date_add_btn {
    border: none;
    border-radius: 5px;
    font-family: 'Montserrat', sans-serif;
    font-size: 12px;
    font-weight: 600;
    width: 175px;
    height: 40px;
    position: relative;
    cursor: pointer;
}

.add_employee {
    margin-top: 6px;
    border: none;
    border-radius: 5px;
    font-family: 'Montserrat', sans-serif;
    font-size: 18px;
    font-weight: 600;
    width: 300px;
    height: 40px;
    position: relative;
    cursor: pointer;
}

@media (max-width: 1310px) {
    .add_employee {
        padding: 0 10px;
    }
}

.add_employee > img {
    position: absolute;
    width: 18px;
    left: 10px;
    top: 30%;
}

@media (max-width: 1560px) {
    .add_employee > img {
        display: none;
    }
}

.custom_calendar > .rdrCalendarWrapper {
    margin-top: 2rem;
    background-color: #ffffff!important;
    border-radius: 10px;
    box-shadow: 0px 1px 30px rgba(53,70,171,0.14);
}
.rdrDay {
    background: #ffffff!important;
}

`, "",{"version":3,"sources":["webpack://./src/Components/SimpleComponents/CalendarContainer.css"],"names":[],"mappings":"AAAA;IACI,iBAAiB;IACjB,YAAY;IACZ,YAAY;IACZ,yBAAyB;IACzB,kBAAkB;IAClB,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,kBAAkB;IAClB,mBAAmB;AACvB;AACA;IACI;QACI,YAAY;IAChB;AACJ;AACA;IACI,YAAY;IACZ,kBAAkB;IAClB,qCAAqC;IACrC,eAAe;IACf,gBAAgB;IAChB,YAAY;IACZ,YAAY;IACZ,kBAAkB;IAClB,eAAe;AACnB;;AAEA;IACI,eAAe;IACf,YAAY;IACZ,kBAAkB;IAClB,qCAAqC;IACrC,eAAe;IACf,gBAAgB;IAChB,YAAY;IACZ,YAAY;IACZ,kBAAkB;IAClB,eAAe;AACnB;;AAEA;IACI;QACI,eAAe;IACnB;AACJ;;AAEA;IACI,kBAAkB;IAClB,WAAW;IACX,UAAU;IACV,QAAQ;AACZ;;AAEA;IACI;QACI,aAAa;IACjB;AACJ;;AAEA;IACI,gBAAgB;IAChB,mCAAmC;IACnC,mBAAmB;IACnB,6CAA6C;AACjD;AACA;IACI,6BAA6B;AACjC","sourcesContent":[".lunch_datepicker {\n    margin-left: 10px;\n    width: 176px;\n    height: 50px;\n    border: 1px solid #CDE1EB;\n    border-radius: 5px;\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    padding-left: 15px;\n    padding-right: 10px;\n}\n@media (max-width: 600px) {\n    .lunch_datepicker {\n        width: 150px;\n    }\n}\n.date_add_btn {\n    border: none;\n    border-radius: 5px;\n    font-family: 'Montserrat', sans-serif;\n    font-size: 12px;\n    font-weight: 600;\n    width: 175px;\n    height: 40px;\n    position: relative;\n    cursor: pointer;\n}\n\n.add_employee {\n    margin-top: 6px;\n    border: none;\n    border-radius: 5px;\n    font-family: 'Montserrat', sans-serif;\n    font-size: 18px;\n    font-weight: 600;\n    width: 300px;\n    height: 40px;\n    position: relative;\n    cursor: pointer;\n}\n\n@media (max-width: 1310px) {\n    .add_employee {\n        padding: 0 10px;\n    }\n}\n\n.add_employee > img {\n    position: absolute;\n    width: 18px;\n    left: 10px;\n    top: 30%;\n}\n\n@media (max-width: 1560px) {\n    .add_employee > img {\n        display: none;\n    }\n}\n\n.custom_calendar > .rdrCalendarWrapper {\n    margin-top: 2rem;\n    background-color: #ffffff!important;\n    border-radius: 10px;\n    box-shadow: 0px 1px 30px rgba(53,70,171,0.14);\n}\n.rdrDay {\n    background: #ffffff!important;\n}\n\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
